export default {
    beforeMount(el, binding) {
      el.__clickOutsideHandler__ = (event) => {
        if (!(el.contains(event.target))) {
          binding.value(event);
        }
      };
      document.addEventListener('click', el.__clickOutsideHandler__);
    },
    unmounted(el) {
      document.removeEventListener('click', el.__clickOutsideHandler__);
      el.__clickOutsideHandler__ = null;
    }
  };
